import { createSlice } from '@reduxjs/toolkit'
import { GetProductsResponseType, ProductsType } from '../../actions/types'
import {
  getProducts,
  createProduct,
  getCurrentProduct,
  getProductFromCompany,
} from '../../actions/productsActon'

export interface IProducts {
  product: GetProductsResponseType
  productsFromCurrentCompany: GetProductsResponseType
  currentProduct: ProductsType
  error: any
  isLoading: boolean
  errorImage: any
}

const initialState: IProducts = {
  product: {
    products: [],
    totalCount: 0,
  },
  productsFromCurrentCompany: {
    products: [],
    totalCount: 0,
  },

  currentProduct: {
    id: 0,
    name: '',
    description: '',
    images: [],
    weight: '',
    measurement: '',
    price: '',
    createdAt: '',
    category: {
      id: 0,
      images: [],
      logo: undefined,
      name: '',
      description: undefined,
      createdAt: '',
      company: {
        id: 0,
        name: '',
        role: '',
        city: '',
        address: '',
        contactFullName: '',
        contactPhone: '',
        email: '',
        inn: '',
        description: '',
        isBlocked: false,
        createdAt: '',
        comments: [],
        employees: [],
        images: [],
        logo: undefined,
      },
    },
  },
  isLoading: false,
  error: '',
  errorImage: '',
}

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    resetCurrentProduct: (state) => {
      state.currentProduct = initialState.currentProduct
      state.isLoading = false
      state.error = ''
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProducts.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getProducts.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.product = action.payload
    })
    builder.addCase(getProducts.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getProductFromCompany.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getProductFromCompany.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.productsFromCurrentCompany = action.payload
      state.product = action.payload
    })
    builder.addCase(getProductFromCompany.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getCurrentProduct.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCurrentProduct.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.currentProduct = action.payload
    })
    builder.addCase(getCurrentProduct.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(createProduct.pending, (state) => {
      state.error = ''
    })
    builder.addCase(createProduct.fulfilled, (state, action) => {
      state.error = ''
    })
    builder.addCase(createProduct.rejected, (state, action) => {
      state.error = action.payload
    })
  },
})

export const productsReducer = productsSlice.reducer

export const { resetCurrentProduct } = productsSlice.actions
